
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_139_1_TimelineItem";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_139_1_TimelineItem__root","event":"wds_1_139_1_TimelineItem__event","prefix":"wds_1_139_1_TimelineItem__prefix","line":"wds_1_139_1_TimelineItem__line","defaultIndicator":"wds_1_139_1_TimelineItem__defaultIndicator","label":"wds_1_139_1_TimelineItem__label","labelText":"wds_1_139_1_TimelineItem__labelText","suffix":"wds_1_139_1_TimelineItem__suffix","labelAction":"wds_1_139_1_TimelineItem__labelAction"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"listItemHeight":"18px","inidicatorSize":"7px"}; 
export var vars = {"listItemHeight":"--wds_1_139_1_TimelineItem-listItemHeight","marginBottom":"--wds_1_139_1_TimelineItem-marginBottom"}; 




